module.exports = __webpack_public_path__ + "img/img_25@2x.2e6a9366.png";